// Sentralisert data for Store-siden. Tekstverdier brukes som translation-fallbacks.
import { Shirt, Trophy, ShoppingBag, Users } from 'lucide-react';

import i18n from '../i18n';
import { useTranslation } from 'react-i18next';
const t = (k, o) => i18n.t(k, o);

export const getstoreCategories = () => [
  {
    id: 'training',
    titleKey: 'store.items.training',
    titleFallback: t('pg.storeData.0af47a'),
    descKey: 'store.items.trainingDesc',
    descFallback: t('pg.storeData.48a8dc'),
    icon: Shirt,
  },
  {
    id: 'match',
    titleKey: 'store.items.match',
    titleFallback: t('pg.storeData.7b28d5'),
    descKey: 'store.items.matchDesc',
    descFallback: t('pg.storeData.400a6b'),
    icon: Trophy,
  },
  {
    id: 'outerwear',
    titleKey: 'store.items.outerwear',
    titleFallback: t('pg.storeData.5d2a5d'),
    descKey: 'store.items.outerwearDesc',
    descFallback: t('pg.storeData.d0c928'),
    icon: ShoppingBag,
  },
  {
    id: 'supporter',
    titleKey: 'store.items.supporter',
    titleFallback: t('pg.storeData.c097ed'),
    descKey: 'store.items.supporterDesc',
    descFallback: t('pg.storeData.0c3699'),
    icon: Users,
  },
];
